import { makeAutoObservable } from "mobx";
import { BaseSearchObject, SearchObject, SearchVat } from "app/common/Model/SearchObject";
import { deleteServiceVat, getServiceVatById, pagingServiceVat, saveOrUpdateServiceVat } from "app/services/ServiceVat";
import { toast } from "react-toastify";
import { VatType } from "app/common/Model/Vat";
import { downloadVAT, importExcelVAT } from "app/services/ImportExcelService";
import moment from "moment";
export default class VatStore {
    openVatCreateOrUpdate = false;
    searchVat = new SearchVat();
    pageVat = null;
    selectedVat = new VatType();
    openConfirmDeleteVAT = false;
    constructor() {
        makeAutoObservable(this);
    }

    pagingVat = async () => {
        return await pagingServiceVat(this.searchVat)
            .then(({ data }) => {
                this.pageVat = data;
            })
            .catch((error) => {
                toast.error("Lấy dữ liệu VAT có lỗi");
            });
    };

    handleOpenFormCreateOrEdit = (vatId) => {
        if (vatId) {
            getServiceVatById(vatId)
                .then(({ data }) => {
                    this.selectedVat = data;
                    this.openVatCreateOrUpdate = true;
                })
                .catch((error) => {
                    toast.error("Lấy dữ liệu VAT có lỗi");
                    console.error("Lỗi lấy dữ liệu VAT:", error);
                });
        } else {
            this.selectedVat = new VatType();
            this.openVatCreateOrUpdate = true;
        }
    };

    handleCreateOrEdit = async (vatData) => {
        try {
            const { data } = await saveOrUpdateServiceVat(vatData);
            toast.success("Lưu VAT thành công!");
            this.handleClosePopup();
            await this.pagingVat();
            return data;
        } catch (error) {
            toast.error("Lưu VAT thất bại!");
            console.error("Lưu VAT thất bại!:", error);
        }
    };

    handleDelete = async () => {
        const vatId = this.selectedVat?.id;
        if (!vatId) return;

        deleteServiceVat(vatId)
            .then(() => {
                // Nếu đang ở trang > 1 và chỉ còn 1 dòng dữ liệu, thì lùi về trang trước
                if (
                    this.searchVat?.pageIndex > 1 &&
                    this.pageVat?.content?.length === 1
                ) {
                    this.searchVat.pageIndex -= 1;
                }
                toast.success("Xóa VAT thành công!");
                this.pagingVat();
                this.handleClosePopup();
            })
            .catch((error) => {
                console.error("Lỗi khi xóa VAT:", error);
                toast.error("Xóa VAT thất bại!");
            });
    };

    handleChangeFormSearch = (searchVat) => {
        this.searchVat = {
            ...this.searchVat,
            ...searchVat,
        };
        this.pagingVat();
    };

    handleDeleteVAT = (VAT) => {
        this.selectedVat = VAT;
        this.openConfirmDeleteVAT = true;
    };

    handleClosePopup = () => {
        this.openVatCreateOrUpdate = false;
        this.openConfirmDeleteVAT = false;
    };
    handleDownloadVAT = async () => {
        try {
            const res = await downloadVAT();
            const url = window.URL.createObjectURL(res?.data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                "MAU_NHAP_VAT" + moment(new Date()).format("DDMMYYYY-HHmm") + ".xlsx"
            );
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.log(error);
        }
    };
    handleImportExcelVAT = (file) => {
        importExcelVAT(file)
            .then(({ data }) => {
                toast.success("Tải file thành công!");
                // this.handleClosePopup();
                this.pagingVat();
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            });
    };
    resetStore = () => {
        this.searchVat = new SearchVat();
        this.pageVat = null;
        this.selectedVat = new VatType();
        this.openVatCreateOrUpdate = false;
    };
}
